import { z } from 'zod'

export const MeterReadingRowSchema = z.object({
  reading_id:         z.string(),
  booth_id:           z.string().nullable(),
  booth_code:         z.string().nullable(),
  full_booth_code:    z.string().nullable(),
  store_code:         z.string().nullable(),
  machine_code:       z.string().nullable(),
  patrol_date:        z.string().nullable(),
  read_time:          z.string().nullable(),
  in_meter:           z.number().nullable(),
  in_meter_2:         z.number().nullable().optional(), // D-156: 2本目以降の IN(デカクレ IN 500円 等)
  in_meter_3:         z.number().nullable().optional(),
  in_meter_4:         z.number().nullable().optional(),
  out_meter:          z.number().nullable(),
  out_meter_2:        z.number().nullable(),
  out_meter_3:        z.number().nullable(),
  in_diff:            z.number().nullable(),
  out_diff_1:         z.number().nullable(),
  out_diff_2:         z.number().nullable(),
  out_diff_3:         z.number().nullable(),
  prize_id:           z.string().nullable(),
  prize_name:         z.string().nullable(),
  prize_id_2:         z.string().nullable().optional(), // D-495: 景品行2/3 の景品マスタ紐付け
  prize_id_3:         z.string().nullable().optional(),
  prize_name_2:       z.string().nullable(),
  prize_name_3:       z.string().nullable(),
  prize_cost:         z.number().nullable(),
  prize_cost_1:       z.number().nullable(),
  prize_cost_2:       z.number().nullable(),
  prize_cost_3:       z.number().nullable(),
  prize_stock_count:  z.number().nullable(),
  prize_restock_count: z.number().nullable(),
  stock_2:            z.number().nullable(),
  stock_3:            z.number().nullable(),
  restock_2:          z.number().nullable(),
  restock_3:          z.number().nullable(),
  theoretical_stock:  z.number().nullable(),
  payout_rate:        z.number().nullable(),
  set_a:              z.string().nullable(),
  set_c:              z.string().nullable(),
  set_l:              z.string().nullable(),
  set_r:              z.string().nullable(),
  set_o:              z.string().nullable(),
  // SPEC-EXTRA-SETTING-FIELDS-V1 (D-592): 機種ごとの追加設定値 {key: value}。
  //   ★zod の既定は「知らないキーを捨てる」。ここに書かないと保存も表示も黙って消える
  //     (D-579 で installed_at が毎回 null で上書きされていたのと同じ事故)。
  set_ext:            z.record(z.string(), z.any()).nullable().optional(),
  entry_type:         z.enum(['patrol', 'replace', 'collection', 'carry_forward']).nullable(),
  revenue:            z.number().nullable(),
  play_price:         z.number().nullable(),
  note:               z.string().nullable(),
  source:             z.string().nullable(),
  input_method:       z.string().nullable(),
  staff_id:           z.string().nullable(),
  ocr_confidence:     z.number().nullable(),
  ocr_raw_text:       z.string().nullable(),
  ocr_attempted_at:   z.string().nullable(),
  photo_url:          z.string().nullable(),
  cropped_photo_url:  z.string().nullable(),
  organization_id:    z.string(),
  created_at:         z.string().nullable(),
  created_by:         z.string().nullable(),
  updated_at:         z.string().nullable(),
  updated_by:         z.string().nullable(),
})
